import { render, staticRenderFns } from "./FooterTemplate.vue?vue&type=template&id=5162c1a8&scoped=true"
import script from "./FooterTemplate.vue?vue&type=script&lang=js"
export * from "./FooterTemplate.vue?vue&type=script&lang=js"
import style0 from "./FooterTemplate.vue?vue&type=style&index=0&id=5162c1a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5162c1a8",
  null
  
)

export default component.exports